export default __webpack_public_path__ + "static/media/poster_delivery.20272f29.jpg";